module.exports = __webpack_public_path__ + "static/media/23-3.920df839.mp3";